import { render, staticRenderFns } from "./RmsDamdangModal.vue?vue&type=template&id=492485c6&"
import script from "./RmsDamdangModal.vue?vue&type=script&lang=js&"
export * from "./RmsDamdangModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports